import { render, staticRenderFns } from "./GroupInsurance.vue?vue&type=template&id=b6f6f234&scoped=true&"
import script from "./GroupInsurance.vue?vue&type=script&lang=js&"
export * from "./GroupInsurance.vue?vue&type=script&lang=js&"
import style0 from "./GroupInsurance.vue?vue&type=style&index=0&id=b6f6f234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f6f234",
  null
  
)

export default component.exports